import { hotSeries } from '@/mocks/series';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function HotSeries() {
  return (
    <section id="series" className="py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          tag="热门剧集"
          title="正在热播的电视剧，追更不用等太久"
          desc="整理正在更新的热门剧集，标注当前集数与更新时间，想看更新节奏一目了然。完结的剧也可以一次性刷完。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {hotSeries.map((series) => (
            <article
              key={series.id}
              className="flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="relative w-[92px] sm:w-[112px] h-[132px] sm:h-[160px] flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={series.poster}
                  alt={`电视剧《${series.title}》海报`}
                  title={`${series.title} 电视剧 在线观看`}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0 flex flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 truncate">
                    {series.title}
                  </h3>
                  <span className="flex-shrink-0 px-1.5 py-0.5 rounded-md bg-accent-100 text-accent-800 text-xs font-bold">
                    {series.rating.toFixed(1)}
                  </span>
                </div>

                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1.5 text-[11px] md:text-xs text-foreground-500">
                  <span>{series.region}</span>
                  <span className="w-0.5 h-0.5 rounded-full bg-foreground-300"></span>
                  <span>{series.year}</span>
                  <span className="w-0.5 h-0.5 rounded-full bg-foreground-300"></span>
                  <span className="text-primary-600 font-medium">{series.episodeInfo}</span>
                </div>

                <p className="text-xs text-foreground-600 leading-relaxed mt-2.5 line-clamp-2">
                  {series.summary}
                </p>

                <div className="flex flex-wrap items-center gap-1.5 mt-auto pt-3">
                  {series.genres.map((g) => (
                    <span
                      key={g}
                      className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]"
                    >
                      {g}
                    </span>
                  ))}
                  <span className="inline-flex items-center gap-1 text-[11px] text-foreground-500 ml-auto">
                    <i className="ri-time-line"></i>
                    {series.updateSchedule}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}